import api from '../api/apiClient';

const notificationService = {
  getNotifications: async (analysisId, limit = 100) => {
    const response = await api.get(`/notifications?analysisId=${analysisId}&limit=${limit}`);
    return response;
  },

  markAsRead: async (id) => {
    const response = await api.put(`/notifications/${id}/read`);
    return response;
  },

  markAllAsRead: async (analysisId) => {
    const response = await api.put('/notifications/read-all', { analysisId });
    return response;
  }
};

export default notificationService;
